<template>
  <div class="home">
    <app-header></app-header>
    <hero-section></hero-section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from "../components/Header.vue";
import HeroSection from "../components/Hero.vue";
import AppFooter from "../components/Footer.vue";

export default {
  name: "HomePage",
  components: {
    AppHeader,
    HeroSection,
    AppFooter,
  },
};
</script>